import styled from 'styled-components';
import { H4 } from 'components/Typography';
import { th } from 'style/theme';
import _Spinner from 'components/Spinner';

export const Spinner = styled(_Spinner)`
  margin-top: 74px;
`;

export const Heading = styled(H4)`
  margin-bottom: 24px;
  color: ${th('colors.white')};
`;

export const Terms = styled.div`
  font-weight: 500;
  margin: 24px 0;

  > span {
    text-decoration: underline;
    cursor: pointer;
  }
`;
